function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DEFAULT_PLACEMENT, filterSelectableDimensions, findSelectedValueName } from "../../lib/Models/SelectableDimensions/SelectableDimensions";
describe("SelectableDimension", () => {
  describe("filterSelectableDimensions", () => {
    const filterDefaultPlacement = filterSelectableDimensions(DEFAULT_PLACEMENT);
    it("should filter out selectable dimensions with no options", () => {
      const dimWithNoOptions = {
        setDimensionValue: () => {}
      };
      expect(filterDefaultPlacement([dimWithNoOptions]).length).toBe(0);
    });
    it("should filter out selectable dimensions with only one option and disabled undefined", () => {
      const dimWithOneOption = mkSelectableSelect(DEFAULT_PLACEMENT, [{
        id: "id",
        name: "name"
      }]);
      expect(filterDefaultPlacement([dimWithOneOption]).length).toBe(0);
    });
    it("will not filter out things with only one option and enabled undefined", () => {
      const dimWithOneOptionAllowUndef = _objectSpread(_objectSpread({}, mkSelectableSelect(DEFAULT_PLACEMENT, [{
        id: "id",
        name: "name"
      }])), {}, {
        allowUndefined: true
      });
      expect(filterDefaultPlacement([dimWithOneOptionAllowUndef]).length).toBe(1);
    });
    it("should gracefully handle undefined selectableDimensions", () => {
      expect(filterDefaultPlacement(undefined)).toEqual([]);
    });
  });
  describe("findSelectedValueName", () => {
    it("should return undefined if there is no selection", () => {
      const dimWithNoSelection = mkSelectableSelect(DEFAULT_PLACEMENT, [{
        id: "id",
        name: "name"
      }]);
      expect(findSelectedValueName(dimWithNoSelection)).toBe(undefined);
    });
    it("should return name of selection for selects", () => {
      const dimWithNoSelection = _objectSpread(_objectSpread({}, mkSelectableSelect(DEFAULT_PLACEMENT, [{
        id: "id",
        name: "name"
      }, {
        id: "id2",
        name: "name2"
      }])), {}, {
        selectedId: "id"
      });
      expect(findSelectedValueName(dimWithNoSelection)).toBe("name");
    });
  });
  it("should return disabled for checkboxes with no selection", () => {
    const checkboxWithNoSelection = mkSelectableCheckbox(DEFAULT_PLACEMENT);
    expect(findSelectedValueName(checkboxWithNoSelection)).toBe("Disabled");
  });
  it("should return enabled for checkboxes with true selection", () => {
    const checkboxWithSelection = _objectSpread(_objectSpread({}, mkSelectableCheckbox(DEFAULT_PLACEMENT)), {}, {
      selectedId: "true"
    });
    expect(findSelectedValueName(checkboxWithSelection)).toBe("Enabled");
  });
});
function mkSelectableCheckbox(placement) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    type: "checkbox",
    setDimensionValue: () => undefined,
    placement,
    options
  };
}
function mkSelectableSelect() {
  let placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    type: "select",
    setDimensionValue: () => undefined,
    placement,
    options
  };
}